/**
 * Modelo de Contextos de APIs.
 */
export class ConfigBackEndModel {

    private _nameContext : string;
    private _contextAPI : string;

    constructor(nameContext: string, contextAPI: string) {
        this._nameContext = nameContext;
        this._contextAPI = contextAPI;
    }

    public getNameContext() : string {
        return this._nameContext;
    }

    public getContextAPI() : string {
        return this._contextAPI;
    }
}